import { useTranslation } from 'react-i18next';
import type { SiteInfo } from '@/lib/types';

export function useSiteInfo(): SiteInfo {
  const { t } = useTranslation();
  const raw = t('common.site', { returnObjects: true });
  if (typeof raw === 'object' && raw !== null) {
    return raw as unknown as SiteInfo;
  }
  return {
    brandKo: '한국고무공업주식회사',
    brandShort: '한국고무공업',
    brandEn: 'HANKUK RUBBER TECH. CO.,LTD.',
    tel: '031-434-0341',
    telLink: 'tel:031-434-0341',
    email: 'hkrubbert@naver.com',
    emailLink: 'mailto:hkrubbert@naver.com',
    fax: '031-434-0340',
    address: '경기도 시흥시 옥구천서로 237번길 36',
    established: 1975,
    experienceYears: 50,
  };
}